import React, { Component } from 'react';
import './App.css';
import LoginScreen from './Loginscreen';
import ViewExpense from './ViewExpense';
import { Route, Switch, Redirect } from 'react-router-dom';

class App extends Component {
  constructor(props){
    super(props);
    this.state={
      loginPage:[],
      uploadScreen:[]
    }
  }
  componentWillMount(){
    var loginPage =[];
    loginPage.push(<LoginScreen appContext={this} key={"login-screen"}/>);
    this.setState({
                  loginPage:loginPage
                    })
  }
 
  render() {
    <Switch>
    <Route exact path="/test1" component={ViewExpense} />
    
    {/* <Route exact path="/About" component={About} /> */}
  </Switch>
    return (
      
      <div className="App">
        {this.state.loginPage}
        {this.state.uploadScreen}
      
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js